export default __webpack_public_path__ + "static/media/reservation.1e4d4b25.svg";